export default __webpack_public_path__ + "static/media/weihnachtsmarkt2.f417fccf.png";